package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class ContractorRepository(private val httpClient: HttpClient) {
    suspend fun getContractors(workplaceId: Long): Result<List<StaffMemberFullDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/contractors").body()
    }

    suspend fun addContractor(workplaceId: Long, req: AddContractorRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/contractors") { setBody(req) }
    }

    suspend fun deleteContractor(contractorId: Long): Result<Unit> = runCatching {
        httpClient.delete("contractors/$contractorId")
    }
}
